/**
 * IaQoBo Hotel Module
 */

// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Afidium
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { RatingModule } from 'libraries/component/rating/rating.module';
import { DatePipeModule } from 'libraries/date/date.module';
import { UIModule } from 'libraries/ui/ui.module';
import { SharedModule } from '../shared/components/shared.module';
import { HelperService } from 'libraries/hotel/services/helper.service';
import { HotelService } from 'libraries/hotel/services/hotel.service';
import { LanguageService } from 'libraries/service/language/language.service';
import { ViewService } from 'libraries/hotel/services/view.service';

import { ROUTES } from './routes';

import { SharedData } from 'libraries/hotel/shared-data';
import { BreadcrumbService } from 'libraries/hotel/services/breadcrumb.service';
import { SearchService } from 'libraries/hotel/services/search.service';

import { IqbhMapModule } from 'libraries/hotel/components/iqbh-map/iqbh-map.module';
import { ButtonModule } from 'libraries/module/formbuilder/fields/button/button.module';
import { HotelModule } from 'libraries/hotel/components/hotel/hotel.module';
import { OffersModule } from 'libraries/hotel/components/offers/offers.module';
import { SearchModule } from './containers/search/search.module';
import { ConfigSharedHotelModule } from "libraries/service/resources/configuration/config-shared-hotel.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DatePipeModule,
        UIModule,
        LoaderModule,
        RatingModule,
        SharedModule,
        IqbhMapModule,
        ButtonModule,
        RouterModule.forChild(ROUTES),
        HotelModule,
        OffersModule,
        SearchModule,
        ConfigSharedHotelModule,
    ],
    providers: [
        HotelService,
        HelperService,
        LanguageService,
        ViewService,
        BreadcrumbService,
        SharedData,
        SearchService
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ]
})
export class SearchPageModule { }
